module.exports = __webpack_public_path__ + "img/banner.b593ba42.png";